import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Logo, Btn } from '@/components/ui'
import { C } from '@/constants/theme'
import { NAV_LINKS, WA_URL } from '@/constants/data'

export function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40)
    window.addEventListener('scroll', fn)
    return () => window.removeEventListener('scroll', fn)
  }, [])

  useEffect(() => { setMenuOpen(false) }, [location])

  const isActive = (path: string) => location.pathname === path

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      background: 'rgba(255,255,255,0.96)', backdropFilter: 'blur(12px)',
      borderBottom: `1px solid ${scrolled ? C.grayBorder : 'transparent'}`,
      transition: 'all 0.3s',
      boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.06)' : 'none',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 68 }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <Logo size={36} />
        </Link>

        {/* Desktop */}
        <div className="gt-desktop-nav" style={{ display: 'flex', gap: 32, alignItems: 'center' }}>
          {NAV_LINKS.map(link => {
            const path = link === 'Home' ? '/' : `/${link.toLowerCase()}`
            return (
              <Link
                key={link}
                to={path}
                style={{
                  fontFamily: "'Rajdhani', sans-serif", fontWeight: 600, fontSize: 13,
                  letterSpacing: 2, textTransform: 'uppercase', textDecoration: 'none',
                  color: isActive(path) ? C.blue : C.textMid,
                  borderBottom: isActive(path) ? `2px solid ${C.blue}` : '2px solid transparent',
                  paddingBottom: 2, transition: 'color 0.2s',
                }}
              >
                {link}
              </Link>
            )
          })}
          <a href={WA_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <Btn size="sm">Get a Quote</Btn>
          </a>
        </div>

        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="gt-hamburger"
          aria-label="Toggle menu"
          style={{ display: 'none', background: 'none', border: 'none', cursor: 'pointer', flexDirection: 'column', gap: 5, padding: 4 }}
        >
          {[0,1,2].map(i => <div key={i} style={{ width: 24, height: 2, background: C.blue }} />)}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{ background: C.white, padding: '16px 24px', borderTop: `1px solid ${C.grayBorder}` }}>
          {NAV_LINKS.map(l => ({ label: l, path: l === 'Home' ? '/' : `/${l.toLowerCase()}` })).map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              style={{ display: 'block', padding: '12px 0', fontFamily: "'Rajdhani', sans-serif", fontWeight: 600, fontSize: 15, letterSpacing: 2, color: C.text, textDecoration: 'none', borderBottom: `1px solid ${C.grayMid}` }}
            >
              {label.toUpperCase()}
            </Link>
          ))}
          <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'block', padding: '12px 0', fontFamily: "'Rajdhani', sans-serif", fontWeight: 600, fontSize: 15, letterSpacing: 2, color: C.text, textDecoration: 'none', borderBottom: `1px solid ${C.grayMid}` }}
          >
            GET A QUOTE
          </a>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .gt-desktop-nav { display: none !important; }
          .gt-hamburger { display: flex !important; }
        }
      `}</style>
    </nav>
  )
}
